<script lang="ts" setup>
	defineProps<{
		loading?: boolean
	}>()
	const formData = ref<LoginParameters>({
		email: '',
		password: '',
		user_type: 'business'
	})
	const isFormEmpty = computed(() => {
		return !!(formData.value.email && formData.value.password)
	})
	const formElement = ref<HTMLFormElement>()
	const emits = defineEmits<{
		(arg: 'done', payload: LoginParameters): void
	}>()
</script>

<template>
	<div>
		<a-form
			ref="formElement"
			:model="formData"
			:validate-messages="antValidateMessages"
			autocomplete
			:colon="false"
			@finish="emits('done', formData)"
		>
			<a-form-item label="Email" name="email" :rules="[{ type: 'email' }]" required class="!mb-[2rem]">
				<a-input
					v-model:value.trim="formData.email"
					type="email"
					data-testid="email"
					placeholder="Enter your email address"
					class="custom-input !bg-gray-50 !px-5"
				/>
			</a-form-item>

			<a-form-item label="Password" name="password" required>
				<a-input-password
					v-model:value="formData.password"
					placeholder="Enter your password"
					data-testid="password"
					autcomplete="new password"
					class="custom-input !bg-gray-50 !px-5"
				/>
			</a-form-item>

			<div class="mt-4 flex items-end justify-end">
				<nuxt-link
					data-testid="reset-password"
					class="text-[14px] font-medium text-primary-2"
					to="/password-reset"
				>
					Forgot Password?
				</nuxt-link>
			</div>

			<a-button
				class="default-btn mt-12 w-full justify-center bg-primary-2"
				:loading="loading"
				:disabled="!isFormEmpty"
				data-testid="login"
				html-type="submit"
			>
				Log In
			</a-button>
			<div
				class="relative mt-5 justify-start text-center text-sm font-medium leading-tight md:text-base md:leading-snug"
			>
				<span class="text-gray-600"> Don't have a business account? </span>
				<nuxt-link to="/register" class="text-main">Sign Up</nuxt-link>
			</div>
		</a-form>
	</div>
</template>
